export { FacetAccordion } from './FacetAccordion';
